import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/99c82431-2962-4549-a63c-924ef4b4485a.jpg'
import { useIntl } from 'react-intl';

const TravbusinessYourSolutionForEasyTravelInvoicesPage: React.FC = () => {
  const { formatMessage } = useIntl();
  const tocItems: ITableOfContentItem[] = [
    { id: 'single-monthly-statement', title: '1. Single Monthly Statement' },
    { id: 'transparent-breakdown', title: '2. Transparent Breakdown' },
    { id: 'automated-billing-integration', title: '3. Automated Billing Integration' },
    { id: 'flexible-payment-options', title: '4. Flexible Payment Options' },
    { id: 'reduced-errors-improved-efficiency', title: '5. Reduced Errors & Improved Efficiency' },
  ];
  
  const sections: IContentSection[] = [
    {
      id: 'single-monthly-statement',
      title: formatMessage({ id: 'easy.travel.sections.singleMonthlyStatement.title' }),
      paragraphs: [
        formatMessage({ id: 'easy.travel.sections.singleMonthlyStatement.para1' }),
        formatMessage({ id: 'easy.travel.sections.singleMonthlyStatement.para2' }),
      ],
    },
    {
      id: 'transparent-breakdown',
      title: formatMessage({ id: 'easy.travel.sections.transparentBreakdown.title' }),
      paragraphs: [
        formatMessage({ id: 'easy.travel.sections.transparentBreakdown.para1' }),
        formatMessage({ id: 'easy.travel.sections.transparentBreakdown.para2' }),
      ],
    },
    {
      id: 'automated-billing-integration',
      title: formatMessage({ id: 'easy.travel.sections.automatedBillingIntegration.title' }),
      paragraphs: [
        formatMessage({ id: 'easy.travel.sections.automatedBillingIntegration.para1' }),
      ],
    },
    {
      id: 'flexible-payment-options',
      title: formatMessage({ id: 'easy.travel.sections.flexiblePaymentOptions.title' }),
      paragraphs: [
        formatMessage({ id: 'easy.travel.sections.flexiblePaymentOptions.para1' }),
      ],
    },
    {
      id: 'reduced-errors-improved-efficiency',
      title: formatMessage({ id: 'easy.travel.sections.reducedErrors.title' }),
      paragraphs: [
        formatMessage({ id: 'easy.travel.sections.reducedErrors.para1' }),
        formatMessage({ id: 'easy.travel.sections.reducedErrors.para2' }),
      ],
    },
  ];

  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={formatMessage({ id: 'easy.travel.invoicing.title' })}
        headerSubtitle={formatMessage({ id: 'easy.travel.invoicing.message' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='top'
      />
    </div>
  );
};

export default TravbusinessYourSolutionForEasyTravelInvoicesPage;
